export default __webpack_public_path__ + "static/media/logo-mexico-asistencia.aa0ca9d7.png";